const ShareOverlay = () => {

	const shareOverlay = document.querySelector('#share-overlay');
	if(!shareOverlay) {
		return;
	}

	document.querySelector('#recipe-share-btn').addEventListener('click', (e) => {
		e.preventDefault();
		document.body.classList.add('js-share-overlay-revealed');
	});

	shareOverlay.querySelector('#share-overlay-close').addEventListener('click', e => {
		e.preventDefault();
		document.body.classList.remove('js-share-overlay-revealed');
	});
};

export default ShareOverlay;